import { apiClient } from './apiClient';

export interface InverterPowerData {
  power: number;
  timestamp: string;
}

export interface HeatmapGridData {
  grid_data: Record<string, Record<string, InverterPowerData>>;
  blocks: string[];
  inverters: string[];
  summary: {
    total_inverters: number;
    total_blocks: number;
    avg_power: number;
  };
}

export interface HeatmapBand {
  lower_bound: number;
  upper_bound: number;
  color_code: string;
  label: string;
}

export interface HeatmapBandsResponse {
  bands: HeatmapBand[];
}

export const inverterPowerService = {
  getActivePower: async (date?: string, plantId?: string): Promise<HeatmapGridData> => {
    const params = new URLSearchParams();
    if (date) params.append('date', date);
    if (plantId) params.append('plant_id', plantId);
    
    const response = await apiClient.get(`/api/monitoring/inverters/active-power/?${params}`);
    return response.data;
  },

  getHeatmapBands: async (): Promise<HeatmapBandsResponse> => {
    const response = await apiClient.get('/api/monitoring/inverters/heatmap-bands/');
    return response.data;
  }
};